import React from "react";
import DemoPage from "./pages/DemoPage";
import InfoPage from "./pages/InfoPage";
import "./index.css";

function App() {
  const path = window.location.pathname.replace(/\/$/, "") || "/";

  if (path === "/about") return <InfoPage page="about" />;
  if (path === "/features") return <InfoPage page="features" />;
  if (path === "/industries") return <InfoPage page="industries" />;
  if (path === "/faq") return <InfoPage page="faq" />;
  if (path === "/contact") return <InfoPage page="contact" />;
  if (path === "/demo") return <InfoPage page="demo" />;

  return (
    <div className="App">
      <DemoPage />
    </div>
  );
}

export default App;